<div>
    <div class="logout-msg-div ">
    You are about to log out from LMS Remote care Application. <br>
    Are you sure want to logout ?</div>
    <mat-divider></mat-divider>
        <div class="p-col-12">
            <div id="alarm-modal-btn-contain" class="notes-btn">
                <button id="alarm-item" mat-raised-button class="logout-btn"  (click)="logout()">Logout</button>
                <button id="alarm-cancel-submission" mat-button class="cancel-btn" (click)="cancel()">Cancel</button>
            </div>
        </div>
</div>